import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import TechnicalMapTable from "../../../components/UI/table/orders/organization/technicalmaptable/TechnicalMapTable";
import JobService from "../../../API/orders/job/JobService";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {Box} from "@mui/system";

const TechnicalMap = () => {
    const [alertData, setAlertData] = useState({});
    const params = useParams();
    let orderId = params.id;
    const pathname = useLocation().pathname
    const [technicalMapData, setTechnicalMapData] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    useEffect(() => {
        getStartPageSize()
        JobService.getJobsByOrderId(orderId).then(function (response) {
            const data = (response.data ?? []).sort((a, b) => a.outputPriority - b.outputPriority);
            setTechnicalMapData(data);
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Техническая карта заказа: ${params.order}`}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Производство", href: "/organization/orders-production"},
                ]}/>
            <Typography component="p" sx={{paddingBottom: "10px", fontSize: "24px", fontWeight: 700}}>
                Техническая карта заказа: {params.order}
            </Typography>
            <TechnicalMapTable
                data={technicalMapData}
                setData={setTechnicalMapData}
                estimateIsCurrent={true}
                production={true}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default TechnicalMap;